import { Filter, textAll, textMultiple, textPlaceholder } from '@Component/Filter/utils.ts';
import { JSX } from 'react';
import { AsyncDropdownOptions, DropdownFilter, SearchFilter, ToggleFilter } from '@tlx/astro-shared';
import { Option } from '@tlx/atlas';
import { IntlShape } from 'react-intl';
import { DropdownUrls } from '@Util/urls.ts';

type FilterProps = {
    filter: Filter;
    intl: IntlShape;
};

const createSalaryTableFilters: {
    [key: string]: (props: FilterProps) => JSX.Element;
} = {
    searchFilter: ({ filter }) => <SearchFilter {...filter} />,
    employeeAvailabilityFilter: ({ filter }) => <ToggleFilter {...filter} />,
    employeeCategoryFilter: ({ filter, intl }) => (
        <DropdownFilter
            {...filter}
            defaultDisplayName={textAll(filter, intl)}
            multiple
            placeholder={textPlaceholder(filter, intl)}
            selectedItemsLabel={(count) => textMultiple(filter, count)}
        >
            <Option value="-2">{intl.formatMessage({ id: 'option_none' })}</Option>
            <AsyncDropdownOptions url={DropdownUrls.EMPLOYEE_CATEGORIES} />
        </DropdownFilter>
    ),
    departmentFilter: ({ filter, intl }) => (
        <DropdownFilter
            {...filter}
            defaultDisplayName={textAll(filter, intl)}
            multiple
            selectedItemsLabel={(count) => textMultiple(filter, count)}
            placeholder={textPlaceholder(filter, intl)}
        >
            <AsyncDropdownOptions url={DropdownUrls.ACTIVE_DEPARTMENTS} />
        </DropdownFilter>
    ),
    divisionFilter: ({ filter, intl }) => (
        <DropdownFilter
            {...filter}
            defaultDisplayName={textAll(filter, intl)}
            multiple
            selectedItemsLabel={(count) => textMultiple(filter, count)}
            placeholder={textPlaceholder(filter, intl)}
        >
            <AsyncDropdownOptions url={DropdownUrls.DIVISIONS} />
        </DropdownFilter>
    ),
    contactsFilter: ({ filter }) => <ToggleFilter {...filter} defaultChecked={true} />,
};

export const tableFilters = {
    createSalary: createSalaryTableFilters,
} as const;

export type TableWithFilters = keyof typeof tableFilters;
